import { post } from '@eika-infrastruktur/request';

import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { WalletCreditCard, WalletCreditCardFilter } from '@generated-types';

export const getEligibleCreditCards = async (parameters: WalletCreditCardFilter) =>
    post<WalletCreditCard[]>(`${KREDITTBANKEN_BASE_URL}/wallets/credit-cards`, parameters);
